import React from "react";
import { compose } from "recompose";

import requiresAuth from "components/requiresAuth";
import RequireUmbrellaAuth from "components/requireUmbrellaAuth";

import UmbrellaUsersPage from "components/Umbrella/Users/UserPage";

function Users() {
    return <UmbrellaUsersPage menu="umbrella" />;
}

export default compose(requiresAuth, RequireUmbrellaAuth)(Users);
